import React, { useState, useRef } from "react";

function VerficationMsg({ setStep = () => { }, status, handleClose, rejectedReason = "" }) {
  // const [status, setStatus] = useState(false);
  const pendingText = (
    <p className="text-sm text-[#6C757D]">
      Thank you for submitting the agreement ! Your profile is now in the
      pending stage. Please await approval from our GWPartner Admin. If you have
      any questions regarding the process, feel free to reach out to us at{" "}
      <a href="mailto: support@getwork.org" className="text-[#2563EB]">
        support@getwork.org
      </a>
    </p>
  );

  const rejectedText = [
    <p className="text-sm text-[#6C757D]">
      Sorry to inform you but your verification is rejected Reason- {rejectedReason}
    </p>,
  ];

  const handleRedirect = () => {
    if (status === "Pending") handleClose()
    else setStep(1)
  }

  return (
    <div>
      <div className="text-center flex flex-col items-stretch px-16  justify-center pt-3">
        <h2 className=" text-3xl flex justify-center items-center text-center mb-1">
          Verification is{" "}
          <div
            style={{ color: status === "Pending" ? "#2563EB" : "#EF4444" }}
            className="  ml-2 "
          >
            {status}
          </div>
        </h2>
        <div className="mt-1"> {status === "Pending" ? pendingText : rejectedText}</div>
        <div className=" flex flex-col  mt-6 pb-8">
          <button
            onClick={handleRedirect}
            className="bg-[#2563EB] text-white text-center h-[40px] text-sm  rounded-md px-3 font-normal flex justify-center items-center "
          >
            {status === "Pending" ? "Done" : "Verify Again"}
          </button>
        </div>
      </div>
    </div>
  );
}

export default VerficationMsg;
